import { parseAsString, useQueryStates } from "nuqs";
import { createContext, useCallback, useContext, useMemo } from "react";

export interface DraftsFilterState {
  status?: string | null;
}

export interface DraftsFilterContextValue {
  filters: DraftsFilterState;
  setFilters: (filters: DraftsFilterState) => void;

  status: DraftsFilterState["status"];
  setStatus: (status: DraftsFilterState["status"]) => void;
}
export const DraftsFilterContext = createContext<DraftsFilterContextValue | null>(null);

export const DraftsFilterProvider = ({ children }: { children: React.ReactNode }) => {
  const [filters, setFilters] = useQueryStates({
    status: parseAsString,
  });

  const status = filters.status;
  const setStatus = useCallback((status: DraftsFilterState["status"]) => setFilters({ status }), [setFilters]);

  const value: DraftsFilterContextValue = useMemo(
    () => ({
      filters,
      setFilters,
      status,
      setStatus,
    }),
    [filters, setFilters, status, setStatus]
  );

  return <DraftsFilterContext.Provider value={value}>{children}</DraftsFilterContext.Provider>;
};

export const useDraftsFilter = () => {
  const context = useContext(DraftsFilterContext);
  if (!context) {
    throw new Error("useDraftsFilter must be used within a DraftsFilterProvider");
  }
  return context;
};
